<template>
  <div>
    
    <modal :id="id" :title="title">
      <span v-html="termos"></span>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/modal/Modal";
import TermosService from "@/common/services/termos/termos.service";
import Swal from "sweetalert2";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

export default {
  name: "Termos",
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "modal-termos",
    },
    funcaoEnviar: {
      type: Function,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      termos: "",
    };
  },
  methods: {
    listarTermos() {
      this.$store.dispatch(START_LOADING);
      TermosService.getTermos()
        .then((result) => {
          this.termos = result.data.data;
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  mounted() {
    this.listarTermos();
  },
};
</script>
